import { usePageAccess } from 'hooks'
import { Helmet } from 'react-helmet'
import PosAreaList from './posAreaList'

const PosAreasManagement = () => {
  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Pos Areas Management</title>
      </Helmet>
      <div className="h-full">
        <PosAreaList isEditor={isEditor} />
      </div>
    </>
  )
}

export default PosAreasManagement
